import React, { useState } from 'react';
import dynamic from 'next/dynamic';
import { elements } from '../../../utils/element.type';

const Card = dynamic(() => import('../../../components/wiki/cards/card'));
const Hero = dynamic(() => import('../../../components/wiki/cards/hero'));

export default function Wiki() {
  const [activeItems, setActiveItems] = useState(elements);

  return (
    <main className='flex flex-col'>
      <Hero />
      <Card activeItems={activeItems} setActiveItems={setActiveItems} />
    </main>
  );
}
